// import { getUrlParam } from './';
// import store from '../store';

// 商品区域地址转换
export function addressTransform(data: any): string {
    let addressArr: string[] = [];
    Object.keys(data).forEach((value: string) => {
        addressArr.push(...data[value]);
    });
    return Array.from(new Set(addressArr)).join(',') || '';
}

// 给链接后面拼接合伙人ID
// export function splicingPartnerId(segmentation: string = '&'): string {
//     let partnerId: any = getUrlParam('partnerId') || sessionStorage.getItem('__partnerId') || store.user.partnerId;
//     return `${segmentation}partnerId=${partnerId}`;
// }


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/transform.ts